export const countries: IAddressCountry[] = [
    {id: 1, name: 'Afghanistan', code: 'AF', r: 1, zip: 1},
    {id: 2, name: 'Aland Islands', code: 'AX', r: 2, zip: 1},
    {id: 3, name: 'Albania', code: 'AL', r: 3, zip: 1},
    {id: 4, name: 'Algeria', code: 'DZ', r: 4, zip: 1},
    {id: 5, name: 'American Samoa', code: 'AS', r: 5, zip: 1},
    {id: 6, name: 'Andorra', code: 'AD', r: 6, zip: 1},
    {id: 7, name: 'Angola', code: 'AO', r: 7, zip: 0},
    {id: 8, name: 'Anguilla', code: 'AI', r: 8, zip: 1},
    {id: 9, name: 'Antarctica', code: 'AQ', r: 9, zip: 1},
    {id: 10, name: 'Antigua and Barbuda', code: 'AG', r: 10, zip: 0},
    {id: 11, name: 'Argentina', code: 'AR', r: 11, zip: 1},
    {id: 12, name: 'Armenia', code: 'AM', r: 12, zip: 1},
    {id: 13, name: 'Aruba', code: 'AW', r: 13, zip: 0},
    {id: 14, name: 'Australia', code: 'AU', r: 14, zip: 1},
    {id: 15, name: 'Austria', code: 'AT', r: 15, zip: 1},
    {id: 16, name: 'Azerbaijan', code: 'AZ', r: 16, zip: 1},
    {id: 17, name: 'Bahamas', code: 'BS', r: 17, zip: 0},
    {id: 18, name: 'Bahrain', code: 'BH', r: 18, zip: 1},
    {id: 19, name: 'Bangladesh', code: 'BD', r: 19, zip: 1},
    {id: 20, name: 'Barbados', code: 'BB', r: 20, zip: 1},
    {id: 21, name: 'Belarus', code: 'BY', r: 21, zip: 1},
    {id: 22, name: 'Belgium', code: 'BE', r: 22, zip: 1},
    {id: 23, name: 'Belize', code: 'BZ', r: 23, zip: 0},
    {id: 24, name: 'Benin', code: 'BJ', r: 24, zip: 0},
    {id: 25, name: 'Bermuda', code: 'BM', r: 25, zip: 1},
    {id: 26, name: 'Bhutan', code: 'BT', r: 26, zip: 1},
    {id: 27, name: 'Bolivia', code: 'BO', r: 27, zip: 1},
    {id: 28, name: 'Bosnia and Herzegovina', code: 'BA', r: 28, zip: 1},
    {id: 29, name: 'Botswana', code: 'BW', r: 29, zip: 0},
    {id: 30, name: 'Bouvet Island', code: 'BV', r: 30, zip: 1},
    {id: 32, name: 'British Indian Ocean', code: 'IO', r: 32, zip: 1},
    {id: 33, name: 'Brunei Darussalam', code: 'BN', r: 33, zip: 1},
    {id: 34, name: 'Bulgaria', code: 'BG', r: 34, zip: 1},
    {id: 35, name: 'Burkina Faso', code: 'BF', r: 35, zip: 0},
    {id: 36, name: 'Burundi', code: 'BI', r: 36, zip: 0},
    {id: 37, name: 'Cambodia', code: 'KH', r: 37, zip: 1},
    {id: 38, name: 'Cameroon', code: 'CM', r: 38, zip: 0},
    {id: 39, name: 'Canada', code: 'CA', r: 39, zip: 1},
    {id: 40, name: 'Cape Verde', code: 'CV', r: 40, zip: 1},
    {id: 41, name: 'Cayman Islands', code: 'KY', r: 41, zip: 1},
    {id: 42, name: 'Chad', code: 'TD', r: 42, zip: 1},
    {id: 43, name: 'Chile', code: 'CL', r: 43, zip: 1},
    {id: 44, name: 'China', code: 'CN', r: 44, zip: 1},
    {id: 45, name: 'Colombia', code: 'CO', r: 45, zip: 1},
    {id: 46, name: 'Comoros', code: 'KM', r: 46, zip: 0},
    {id: 47, name: 'Congo', code: 'CG', r: 47, zip: 0},
    {id: 48, name: 'Congo The Dem', code: 'CD', r: 48, zip: 0},
    {id: 49, name: 'Cook Islands', code: 'CK', r: 49, zip: 0},
    {id: 50, name: 'Costa Rica', code: 'CR', r: 50, zip: 1},
    {id: 51, name: 'Cote Divoire', code: 'CI', r: 51, zip: 0},
    {id: 52, name: 'Croatia', code: 'HR', r: 52, zip: 1},
    {id: 54, name: 'Cyprus', code: 'CY', r: 54, zip: 1},
    {id: 55, name: 'Czech Republic', code: 'CZ', r: 55, zip: 1},
    {id: 56, name: 'Denmark', code: 'DK', r: 56, zip: 1},
    {id: 57, name: 'Djibouti', code: 'DJ', r: 57, zip: 0},
    {id: 58, name: 'Dominica', code: 'DM', r: 58, zip: 0},
    {id: 59, name: 'Dominican Republic', code: 'DO', r: 59, zip: 1},
    {id: 60, name: 'Ecuador', code: 'EC', r: 60, zip: 1},
    {id: 61, name: 'Egypt', code: 'EG', r: 61, zip: 1},
    {id: 62, name: 'El Salvador', code: 'SV', r: 62, zip: 1},
    {id: 63, name: 'Equatorial Guinea', code: 'GQ', r: 63, zip: 0},
    {id: 64, name: 'Eritrea', code: 'ER', r: 64, zip: 0},
    {id: 65, name: 'Estonia', code: 'EE', r: 65, zip: 1},
    {id: 66, name: 'Ethiopia', code: 'ET', r: 66, zip: 1},
    {id: 67, name: 'Falkland Islands', code: 'FK', r: 67, zip: 1},
    {id: 68, name: 'Faroe Islands', code: 'FO', r: 68, zip: 1},
    {id: 69, name: 'Fiji', code: 'FJ', r: 69, zip: 0},
    {id: 70, name: 'Finland', code: 'FI', r: 70, zip: 1},
    {id: 71, name: 'France', code: 'FR', r: 71, zip: 1},
    {id: 72, name: 'French Guiana', code: 'GF', r: 72, zip: 1},
    {id: 73, name: 'French Polynesia', code: 'PF', r: 73, zip: 1},
    {id: 74, name: 'French Southern Terr', code: 'TF', r: 74, zip: 0},
    {id: 75, name: 'Gabon', code: 'GA', r: 75, zip: 1},
    {id: 76, name: 'Gambia', code: 'GM', r: 76, zip: 0},
    {id: 77, name: 'Georgia', code: 'GE', r: 77, zip: 1},
    {id: 78, name: 'Germany', code: 'DE', r: 78, zip: 1},
    {id: 79, name: 'Ghana', code: 'GH', r: 79, zip: 0},
    {id: 80, name: 'Gibraltar', code: 'GI', r: 80, zip: 1},
    {id: 81, name: 'Greece', code: 'GR', r: 81, zip: 1},
    {id: 82, name: 'Greenland', code: 'GL', r: 82, zip: 1},
    {id: 83, name: 'Grenada', code: 'GD', r: 83, zip: 0},
    {id: 84, name: 'Guadeloupe', code: 'GP', r: 84, zip: 1},
    {id: 85, name: 'Guam', code: 'GU', r: 85, zip: 1},
    {id: 86, name: 'Guatemala', code: 'GT', r: 86, zip: 1},
    {id: 87, name: 'Guernsey', code: 'GG', r: 87, zip: 1},
    {id: 88, name: 'Guinea', code: 'GN', r: 88, zip: 1},
    {id: 89, name: 'Guyana', code: 'GY', r: 89, zip: 0},
    {id: 90, name: 'Haiti', code: 'HT', r: 90, zip: 1},
    {id: 91, name: 'Heard Island', code: 'HM', r: 91, zip: 1},
    {id: 92, name: 'Holy See', code: 'VA', r: 92, zip: 1},
    {id: 93, name: 'Honduras', code: 'HN', r: 93, zip: 1},
    {id: 94, name: 'Hong Kong', code: 'HK', r: 94, zip: 0},
    {id: 95, name: 'Hungary', code: 'HU', r: 95, zip: 1},
    {id: 96, name: 'Iceland', code: 'IS', r: 96, zip: 1},
    {id: 97, name: 'India', code: 'IN', r: 97, zip: 1},
    {id: 98, name: 'Indonesia', code: 'ID', r: 98, zip: 1},
    {id: 99, name: 'Ireland', code: 'IE', r: 99, zip: 0},
    {id: 100, name: 'Isle of Man', code: 'IM', r: 100, zip: 1},
    {id: 101, name: 'Israel', code: 'IL', r: 101, zip: 1},
    {id: 102, name: 'Italy', code: 'IT', r: 102, zip: 1},
    {id: 103, name: 'Jamaica', code: 'JM', r: 103, zip: 0},
    {id: 104, name: 'Japan', code: 'JP', r: 104, zip: 1},
    {id: 105, name: 'Jersey', code: 'JE', r: 105, zip: 1},
    {id: 106, name: 'Jordan', code: 'JO', r: 106, zip: 1},
    {id: 107, name: 'Kazakhstan', code: 'KZ', r: 107, zip: 1},
    {id: 108, name: 'Kenya', code: 'KE', r: 108, zip: 0},
    {id: 109, name: 'Kiribati', code: 'KI', r: 109, zip: 0},
    {id: 110, name: 'Korea, South', code: 'KR', r: 110, zip: 1},
    {id: 111, name: 'Kuwait', code: 'KW', r: 111, zip: 1},
    {id: 112, name: 'Kyrgyzstan', code: 'KG', r: 112, zip: 1},
    {id: 113, name: 'Lao Peoples Dem', code: 'LA', r: 113, zip: 1},
    {id: 114, name: 'Latvia', code: 'LV', r: 114, zip: 1},
    {id: 115, name: 'Lebanon', code: 'LB', r: 115, zip: 1},
    {id: 116, name: 'Lesotho', code: 'LS', r: 116, zip: 1},
    {id: 117, name: 'Liberia', code: 'LR', r: 117, zip: 1},
    {id: 118, name: 'Liechtenstein', code: 'LI', r: 118, zip: 1},
    {id: 119, name: 'Lithuania', code: 'LT', r: 119, zip: 1},
    {id: 120, name: 'Luxembourg', code: 'LU', r: 120, zip: 1},
    {id: 121, name: 'Macao', code: 'MO', r: 121, zip: 0},
    {id: 122, name: 'Macedonia', code: 'MK', r: 122, zip: 1},
    {id: 123, name: 'Madagascar', code: 'MG', r: 123, zip: 1},
    {id: 124, name: 'Malawi', code: 'MW', r: 124, zip: 0},
    {id: 125, name: 'Malaysia', code: 'MY', r: 125, zip: 1},
    {id: 126, name: 'Maldives', code: 'MV', r: 126, zip: 1},
    {id: 127, name: 'Mali', code: 'ML', r: 127, zip: 0},
    {id: 128, name: 'Malta', code: 'MT', r: 128, zip: 1},
    {id: 129, name: 'Marshall Islands', code: 'MH', r: 129, zip: 1},
    {id: 130, name: 'Martinique', code: 'MQ', r: 130, zip: 1},
    {id: 131, name: 'Mauritania', code: 'MR', r: 131, zip: 0},
    {id: 132, name: 'Mauritius', code: 'MU', r: 132, zip: 0},
    {id: 133, name: 'Mayotte', code: 'YT', r: 133, zip: 1},
    {id: 134, name: 'Mexico', code: 'MX', r: 134, zip: 1},
    {id: 135, name: 'Micronesia', code: 'FM', r: 135, zip: 1},
    {id: 136, name: 'Moldova, Republic of', code: 'MD', r: 136, zip: 1},
    {id: 137, name: 'Monaco', code: 'MC', r: 137, zip: 1},
    {id: 138, name: 'Mongolia', code: 'MN', r: 138, zip: 1},
    {id: 139, name: 'Montenegro', code: 'ME', r: 139, zip: 1},
    {id: 140, name: 'Montserrat', code: 'MS', r: 140, zip: 0},
    {id: 141, name: 'Morocco', code: 'MA', r: 141, zip: 1},
    {id: 142, name: 'Mozambique', code: 'MZ', r: 142, zip: 1},
    {id: 143, name: 'Myanmar', code: 'MM', r: 143, zip: 1},
    {id: 144, name: 'Namibia', code: 'NA', r: 144, zip: 1},
    {id: 145, name: 'Nauru', code: 'NR', r: 145, zip: 0},
    {id: 146, name: 'Nepal', code: 'NP', r: 146, zip: 1},
    {id: 147, name: 'Netherlands', code: 'NL', r: 147, zip: 1},
    {id: 148, name: 'Netherlands Antilles', code: 'AN', r: 148, zip: 0},
    {id: 149, name: 'New Caledonia', code: 'NC', r: 149, zip: 1},
    {id: 150, name: 'New Zealand', code: 'NZ', r: 150, zip: 1},
    {id: 151, name: 'Nicaragua', code: 'NI', r: 151, zip: 1},
    {id: 152, name: 'Niger', code: 'NE', r: 152, zip: 1},
    {id: 153, name: 'Nigeria', code: 'NG', r: 153, zip: 1},
    {id: 154, name: 'Niue', code: 'NU', r: 154, zip: 0},
    {id: 155, name: 'Norfolk Island', code: 'NF', r: 155, zip: 1},
    {id: 156, name: 'Northern Mariana Islands', code: 'MP', r: 156, zip: 1},
    {id: 157, name: 'Norway', code: 'NO', r: 157, zip: 1},
    {id: 158, name: 'Oman', code: 'OM', r: 158, zip: 1},
    {id: 159, name: 'Pakistan', code: 'PK', r: 159, zip: 1},
    {id: 160, name: 'Palau', code: 'PW', r: 160, zip: 1},
    {id: 161, name: 'Panama', code: 'PA', r: 161, zip: 0},
    {id: 162, name: 'Papua New Guinea', code: 'PG', r: 162, zip: 1},
    {id: 163, name: 'Paraguay', code: 'PY', r: 163, zip: 1},
    {id: 164, name: 'Peru', code: 'PE', r: 164, zip: 1},
    {id: 165, name: 'Philippines', code: 'PH', r: 165, zip: 1},
    {id: 166, name: 'Pitcairn', code: 'PN', r: 166, zip: 1},
    {id: 167, name: 'Poland', code: 'PL', r: 167, zip: 1},
    {id: 168, name: 'Portugal', code: 'PT', r: 168, zip: 1},
    {id: 169, name: 'Puerto Rico', code: 'PR', r: 169, zip: 1},
    {id: 170, name: 'Qatar', code: 'QA', r: 170, zip: 0},
    {id: 171, name: 'Reunion Island', code: 'RE', r: 171, zip: 1},
    {id: 172, name: 'Romania', code: 'RO', r: 172, zip: 1},
    {id: 174, name: 'Rwanda', code: 'RW', r: 174, zip: 0},
    {id: 175, name: 'Saint Helena', code: 'SH', r: 175, zip: 1},
    {id: 176, name: 'Saint Lucia', code: 'LC', r: 176, zip: 0},
    {id: 177, name: 'Saint Pierre', code: 'PM', r: 177, zip: 1},
    {id: 178, name: 'Saint Vincent', code: 'VC', r: 178, zip: 1},
    {id: 179, name: 'Samoa', code: 'WS', r: 179, zip: 1},
    {id: 180, name: 'San Marino', code: 'SM', r: 180, zip: 1},
    {id: 181, name: 'Saudi Arabia', code: 'SA', r: 181, zip: 0},
    {id: 182, name: 'Senegal', code: 'SN', r: 182, zip: 1},
    {id: 183, name: 'Serbia', code: 'RS', r: 183, zip: 1},
    {id: 184, name: 'Seychelles', code: 'SC', r: 184, zip: 0},
    {id: 185, name: 'Singapore', code: 'SG', r: 185, zip: 1},
    {id: 186, name: 'Slovakia', code: 'SK', r: 186, zip: 1},
    {id: 187, name: 'Slovenia', code: 'SI', r: 187, zip: 1},
    {id: 188, name: 'Solomon Islands', code: 'SB', r: 188, zip: 0},
    {id: 189, name: 'Somalia', code: 'SO', r: 189, zip: 0},
    {id: 190, name: 'South Africa', code: 'ZA', r: 190, zip: 0},
    {id: 191, name: 'South Georgia', code: 'GS', r: 191, zip: 1},
    {id: 192, name: 'Spain', code: 'ES', r: 192, zip: 1},
    {id: 193, name: 'Sri Lanka', code: 'LK', r: 193, zip: 1},
    {id: 195, name: 'Suriname', code: 'SR', r: 195, zip: 0},
    {id: 196, name: 'Svalbard and Jan Mayen', code: 'SJ', r: 196, zip: 1},
    {id: 197, name: 'Swaziland', code: 'SZ', r: 197, zip: 1},
    {id: 198, name: 'Sweden', code: 'SE', r: 198, zip: 1},
    {id: 199, name: 'Switzerland', code: 'CH', r: 199, zip: 1},
    {id: 200, name: 'Taiwan', code: 'TW', r: 200, zip: 1},
    {id: 201, name: 'Tajikistan', code: 'TJ', r: 201, zip: 1},
    {id: 202, name: 'Tanzania, United Rep', code: 'TZ', r: 202, zip: 0},
    {id: 203, name: 'Thailand', code: 'TH', r: 203, zip: 1},
    {id: 204, name: 'Timor-leste', code: 'TL', r: 204, zip: 1},
    {id: 205, name: 'Togo', code: 'TG', r: 205, zip: 1},
    {id: 206, name: 'Tokelau', code: 'TK', r: 206, zip: 0},
    {id: 207, name: 'Tonga', code: 'TO', r: 207, zip: 0},
    {id: 208, name: 'Tunisia', code: 'TN', r: 208, zip: 1},
    {id: 209, name: 'Turkey', code: 'TR', r: 209, zip: 1},
    {id: 210, name: 'Turkmenistan', code: 'TM', r: 210, zip: 1},
    {id: 211, name: 'Turks and Caicos Islands', code: 'TC', r: 211, zip: 1},
    {id: 212, name: 'Tuvalu', code: 'TV', r: 212, zip: 0},
    {id: 213, name: 'Uganda', code: 'UG', r: 213, zip: 0},
    {id: 214, name: 'Ukraine', code: 'UA', r: 214, zip: 1},
    {id: 215, name: 'United Arab Emirates', code: 'AE', r: 215, zip: 0},
    {id: 216, name: 'United Kingdom', code: 'GB', r: 216, zip: 1},
    {id: 217, name: 'United States', code: 'US', r: 217, zip: 1},
    {id: 218, name: 'United States Minor Islands', code: 'UM', r: 218, zip: 1},
    {id: 229, name: 'United States Virgin Islands', code: 'VI', r: 219, zip: 1},
    {id: 219, name: 'Uruguay', code: 'UY', r: 220, zip: 1},
    {id: 220, name: 'Uzbekistan', code: 'UZ', r: 221, zip: 1},
    {id: 221, name: 'Vanuatu', code: 'VU', r: 222, zip: 0},
    {id: 222, name: 'Venezuela', code: 'VE', r: 223, zip: 1},
    {id: 223, name: 'Vietnam', code: 'VN', r: 224, zip: 1},
    {id: 224, name: 'Wallis and Futuna', code: 'WF', r: 225, zip: 1},
    {id: 225, name: 'Western Sahara', code: 'EH', r: 226, zip: 1},
    {id: 227, name: 'Zambia', code: 'ZM', r: 228, zip: 1},
    {id: 228, name: 'Zimbabwe', code: 'ZW', r: 229, zip: 0},
];

export const states: IAddressState[] = [
    {id: 0, name: 'Select State', code: 'AL1', ddl: 'AL1', cid: 217, r: 8},
    {id: 1, name: 'Armed Forces Africa', code: 'AE', ddl: 'AE1', cid: 217, r: 1},
    {id: 2, name: 'Armed Forces Americas', code: 'AA', ddl: 'AA', cid: 217, r: 2},
    {id: 3, name: 'Armed Forces Canada', code: 'AE', ddl: 'AE2', cid: 217, r: 3},
    {id: 4, name: 'Armed Forces Europe', code: 'AE', ddl: 'AE3', cid: 217, r: 4},
    {id: 5, name: 'Armed Forces Middle East', code: 'AE', ddl: 'AE4', cid: 217, r: 5},
    {id: 6, name: 'Armed Forces Pacific', code: 'AP', ddl: 'AP', cid: 217, r: 6},
    {id: 7, name: 'Alabama', code: 'AL', ddl: 'AL', cid: 217, r: 8},
    {id: 8, name: 'Alaska', code: 'AK', ddl: 'AK', cid: 217, r: 9},
    {id: 59, name: 'Alberta', code: 'AB', ddl: 'AB', cid: 39, r: 1},
    {id: 74, name: 'American Samoa', code: 'AS', ddl: 'AS', cid: 5, r: 1},
    {id: 9, name: 'Arizona ', code: 'AZ', ddl: 'AZ', cid: 217, r: 10},
    {id: 10, name: 'Arkansas', code: 'AR', ddl: 'AR', cid: 217, r: 11},
    {id: 60, name: 'British Columbia', code: 'BC', ddl: 'BC', cid: 39, r: 2},
    {id: 11, name: 'California ', code: 'CA', ddl: 'CA', cid: 217, r: 12},
    {id: 12, name: 'Colorado ', code: 'CO', ddl: 'CO', cid: 217, r: 13},
    {id: 13, name: 'Connecticut', code: 'CT', ddl: 'CT', cid: 217, r: 14},
    {id: 14, name: 'Delaware', code: 'DE', ddl: 'DE', cid: 217, r: 15},
    {id: 15, name: 'District Of Columbia', code: 'DC', ddl: 'DC', cid: 217, r: 16},
    {id: 16, name: 'Florida', code: 'FL', ddl: 'FL', cid: 217, r: 17},
    {id: 17, name: 'Georgia', code: 'GA', ddl: 'GA', cid: 217, r: 18},
    {id: 73, name: 'Guam', code: 'GU', ddl: 'GU', cid: 85, r: 19},
    {id: 18, name: 'Hawaii', code: 'HI', ddl: 'HI', cid: 217, r: 20},
    {id: 19, name: 'Idaho', code: 'ID', ddl: 'ID', cid: 217, r: 21},
    {id: 20, name: 'Illinois', code: 'IL', ddl: 'IL', cid: 217, r: 22},
    {id: 21, name: 'Indiana', code: 'IN', ddl: 'IN', cid: 217, r: 23},
    {id: 22, name: 'Iowa', code: 'IA', ddl: 'IA', cid: 217, r: 24},
    {id: 23, name: 'Kansas', code: 'KS', ddl: 'KS', cid: 217, r: 25},
    {id: 24, name: 'Kentucky', code: 'KY', ddl: 'KY', cid: 217, r: 26},
    {id: 25, name: 'Louisiana', code: 'LA', ddl: 'LA', cid: 217, r: 27},
    {id: 26, name: 'Maine', code: 'ME', ddl: 'ME', cid: 217, r: 28},
    {id: 61, name: 'Manitoba', code: 'MB', ddl: 'MB', cid: 39, r: 3},
    {id: 27, name: 'Maryland', code: 'MD', ddl: 'MD', cid: 217, r: 29},
    {id: 28, name: 'Massachusetts', code: 'MA', ddl: 'MA', cid: 217, r: 30},
    {id: 29, name: 'Michigan', code: 'MI', ddl: 'MI', cid: 217, r: 31},
    {id: 30, name: 'Minnesota', code: 'MN', ddl: 'MN', cid: 217, r: 32},
    {id: 31, name: 'Mississippi', code: 'MS', ddl: 'MS', cid: 217, r: 33},
    {id: 32, name: 'Missouri', code: 'MO', ddl: 'MO', cid: 217, r: 34},
    {id: 33, name: 'Montana', code: 'MT', ddl: 'MT', cid: 217, r: 35},
    {id: 34, name: 'Nebraska', code: 'NE', ddl: 'NE', cid: 217, r: 36},
    {id: 35, name: 'Nevada', code: 'NV', ddl: 'NV', cid: 217, r: 37},
    {id: 62, name: 'New Brunswick', code: 'NB', ddl: 'NB', cid: 39, r: 4},
    {id: 36, name: 'New Hampshire', code: 'NH', ddl: 'NH', cid: 217, r: 38},
    {id: 37, name: 'New Jersey', code: 'NJ', ddl: 'NJ', cid: 217, r: 39},
    {id: 38, name: 'New Mexico', code: 'NM', ddl: 'NM', cid: 217, r: 40},
    {id: 39, name: 'New York', code: 'NY', ddl: 'NY', cid: 217, r: 41},
    {id: 63, name: 'Newfoundland and Labrador', code: 'NL', ddl: 'NL', cid: 39, r: 5},
    {id: 40, name: 'North Carolina', code: 'NC', ddl: 'NC', cid: 217, r: 42},
    {id: 41, name: 'North Dakota', code: 'ND', ddl: 'ND', cid: 217, r: 43},
    {id: 64, name: 'Northwest Territories', code: 'NT', ddl: 'NT', cid: 39, r: 6},
    {id: 65, name: 'Nova Scotia', code: 'NS', ddl: 'NS', cid: 39, r: 7},
    {id: 66, name: 'Nunavut', code: 'NU', ddl: 'NU', cid: 39, r: 8},
    {id: 42, name: 'Ohio', code: 'OH', ddl: 'OH', cid: 217, r: 44},
    {id: 43, name: 'Oklahoma', code: 'OK', ddl: 'OK', cid: 217, r: 45},
    {id: 67, name: 'Ontario', code: 'ON', ddl: 'ON', cid: 39, r: 9},
    {id: 44, name: 'Oregon', code: 'OR', ddl: 'OR', cid: 217, r: 46},
    {id: 45, name: 'Pennsylvania', code: 'PA', ddl: 'PA', cid: 217, r: 47},
    {id: 68, name: 'Prince Edward Island', code: 'PE', ddl: 'PE', cid: 39, r: 10},
    {id: 72, name: 'Puerto Rico', code: 'PR', ddl: 'PR', cid: 217, r: 48},
    {id: 69, name: 'Quebec', code: 'QC', ddl: 'QC', cid: 39, r: 11},
    {id: 47, name: 'Rhode Island', code: 'RI', ddl: 'RI', cid: 217, r: 49},
    {id: 70, name: 'Saskatchewan', code: 'SK', ddl: 'SK', cid: 39, r: 12},
    {id: 48, name: 'South Carolina', code: 'SC', ddl: 'SC', cid: 217, r: 50},
    {id: 49, name: 'South Dakota', code: 'SD', ddl: 'SD', cid: 217, r: 51},
    {id: 50, name: 'Tennessee', code: 'TN', ddl: 'TN', cid: 217, r: 52},
    {id: 51, name: 'Texas', code: 'TX', ddl: 'TX', cid: 217, r: 53},
    {id: 52, name: 'Utah', code: 'UT', ddl: 'UT', cid: 217, r: 54},
    {id: 53, name: 'Vermont', code: 'VT', ddl: 'VT', cid: 217, r: 55},
    {id: 54, name: 'Virginia ', code: 'VA', ddl: 'VA', cid: 217, r: 56},
    {id: 55, name: 'Washington', code: 'WA', ddl: 'WA', cid: 217, r: 57},
    {id: 56, name: 'West Virginia', code: 'WV', ddl: 'WV', cid: 217, r: 58},
    {id: 57, name: 'Wisconsin', code: 'WI', ddl: 'WI', cid: 217, r: 59},
    {id: 58, name: 'Wyoming', code: 'WY', ddl: 'WY', cid: 217, r: 60},
    {id: 71, name: 'Yukon', code: 'YT', ddl: 'YT', cid: 39, r: 13},
    {id: 239, name: 'Baden-Württemberg', code: 'BW', ddl: 'BW', cid: 78, r: 239},
    {id: 240, name: 'Bavaria', code: 'BY', ddl: 'BY', cid: 78, r: 240},
    {id: 241, name: 'Berlin', code: 'BE', ddl: 'BE', cid: 78, r: 241},
    {id: 242, name: 'Brandenburg', code: 'BB', ddl: 'BB', cid: 78, r: 242},
    {id: 243, name: 'Bremen', code: 'HB', ddl: 'HB', cid: 78, r: 243},
    {id: 244, name: 'Hamburg', code: 'HH', ddl: 'HH', cid: 78, r: 244},
    {id: 245, name: 'Hesse', code: 'HE', ddl: 'HE', cid: 78, r: 245},
    {id: 246, name: 'Lower Saxony', code: 'NI', ddl: 'NI', cid: 78, r: 246},
    {id: 247, name: 'Mecklenburg-Vorpommern', code: 'MV', ddl: 'MV', cid: 78, r: 247},
    {id: 248, name: 'North Rhine-Westphalia', code: 'NW', ddl: 'NW', cid: 78, r: 248},
    {id: 249, name: 'Rhineland-Palatinate', code: 'RP', ddl: 'RP', cid: 78, r: 249},
    {id: 250, name: 'Saarland', code: 'SL', ddl: 'SL', cid: 78, r: 250},
    {id: 251, name: 'Saxony', code: 'SN', ddl: 'SN', cid: 78, r: 251},
    {id: 252, name: 'Saxony-Anhalt', code: 'ST', ddl: 'ST', cid: 78, r: 252},
    {id: 253, name: 'Schleswig-Holstein', code: 'SH', ddl: 'SH', cid: 78, r: 253},
    {id: 254, name: 'Thuringia', code: 'TH', ddl: 'TH', cid: 78, r: 254},
    {id: 72, name: 'Akita', code: 'O1', ddl: 'O1', cid: 104, r: 72},
    {id: 73, name: 'Aomori', code: 'O2', ddl: 'O2', cid: 104, r: 73},
    {id: 74, name: 'Chiba', code: 'O3', ddl: 'O3', cid: 104, r: 74},
    {id: 75, name: 'Ehime', code: 'O4', ddl: 'O4', cid: 104, r: 75},
    {id: 76, name: 'Fukui', code: 'O5', ddl: 'O5', cid: 104, r: 76},
    {id: 77, name: 'Fukuoka', code: 'O6', ddl: 'O6', cid: 104, r: 77},
    {id: 78, name: 'Fukushima', code: 'O7', ddl: 'O7', cid: 104, r: 78},
    {id: 79, name: 'Gifu', code: 'O8', ddl: 'O8', cid: 104, r: 79},
    {id: 80, name: 'Gunma', code: 'O9', ddl: 'O9', cid: 104, r: 80},
    {id: 81, name: 'Hiroshima', code: 'OA', ddl: 'OA', cid: 104, r: 81},
    {id: 82, name: 'Hokkaido', code: 'OB', ddl: 'OB', cid: 104, r: 82},
    {id: 83, name: 'Hyogo', code: 'OC', ddl: 'OC', cid: 104, r: 83},
    {id: 84, name: 'Ibaragi', code: 'OD', ddl: 'OD', cid: 104, r: 84},
    {id: 85, name: 'Ibaraki', code: 'OE', ddl: 'OE', cid: 104, r: 85},
    {id: 86, name: 'Ishikawa', code: 'OF', ddl: 'OF', cid: 104, r: 86},
    {id: 87, name: 'Iwate', code: 'OG', ddl: 'OG', cid: 104, r: 87},
    {id: 88, name: 'Kagawa', code: 'OI', ddl: 'OI', cid: 104, r: 88},
    {id: 89, name: 'Kagoshima', code: 'OJ', ddl: 'OJ', cid: 104, r: 89},
    {id: 90, name: 'Kanagawa', code: 'OL', ddl: 'OL', cid: 104, r: 90},
    {id: 91, name: 'Kochi', code: 'OM', ddl: 'OM', cid: 104, r: 91},
    {id: 92, name: 'Kumamoto', code: 'OO', ddl: 'OO', cid: 104, r: 92},
    {id: 93, name: 'Kyoto', code: 'OP', ddl: 'OP', cid: 104, r: 93},
    {id: 94, name: 'Mie', code: 'OQ', ddl: 'OQ', cid: 104, r: 94},
    {id: 95, name: 'Miyagi', code: 'OS', ddl: 'OS', cid: 104, r: 95},
    {id: 96, name: 'Miyazaki', code: 'OT', ddl: 'OT', cid: 104, r: 96},
    {id: 97, name: 'Nagano', code: 'OU', ddl: 'OU', cid: 104, r: 97},
    {id: 98, name: 'Nagasaki', code: 'OV', ddl: 'OV', cid: 104, r: 98},
    {id: 99, name: 'Nara', code: 'OW', ddl: 'OW', cid: 104, r: 99},
    {id: 100, name: 'Niigata', code: 'OX', ddl: 'OX', cid: 104, r: 100},
    {id: 101, name: 'Oita', code: 'OY', ddl: 'OY', cid: 104, r: 101},
    {id: 102, name: 'Okinawa', code: '20', ddl: '20', cid: 104, r: 102},
    {id: 103, name: 'Osaka', code: '21', ddl: '21', cid: 104, r: 103},
    {id: 104, name: 'Saga', code: '22', ddl: '22', cid: 104, r: 104},
    {id: 105, name: 'Saitama', code: '23', ddl: '23', cid: 104, r: 105},
    {id: 106, name: 'Shiga', code: '24', ddl: '24', cid: 104, r: 106},
    {id: 107, name: 'Shimane', code: '25', ddl: '25', cid: 104, r: 107},
    {id: 108, name: 'Shizuoka', code: '26', ddl: '26', cid: 104, r: 108},
    {id: 109, name: 'Tochigi', code: '27', ddl: '27', cid: 104, r: 109},
    {id: 110, name: 'Tokushima', code: '28', ddl: '28', cid: 104, r: 110},
    {id: 111, name: 'Tokyo', code: '29', ddl: '29', cid: 104, r: 111},
    {id: 112, name: 'Tottori', code: '30', ddl: '30', cid: 104, r: 112},
    {id: 113, name: 'Toyama', code: '31', ddl: '31', cid: 104, r: 113},
    {id: 114, name: 'Wakayama', code: '32', ddl: '32', cid: 104, r: 114},
    {id: 115, name: 'Yamagata', code: '33', ddl: '33', cid: 104, r: 115},
    {id: 116, name: 'Yamaguchi', code: '34', ddl: '34', cid: 104, r: 116},
    {id: 117, name: 'Yamanashi', code: '35', ddl: '35', cid: 104, r: 117},
    {id: 118, name: 'Aberdeen', code: 'AB', ddl: 'AB', cid: 216, r: 118},
    {id: 119, name: 'St Albans', code: 'AL', ddl: 'AL', cid: 216, r: 119},
    {id: 120, name: 'Birmingham', code: 'B ', ddl: 'B', cid: 216, r: 120},
    {id: 121, name: 'Bath', code: 'BA', ddl: 'BA', cid: 216, r: 121},
    {id: 122, name: 'Blackburn', code: 'BB', ddl: 'BB', cid: 216, r: 122},
    {id: 123, name: 'Bradford', code: 'BD', ddl: 'BD', cid: 216, r: 123},
    {id: 124, name: 'Bournemouth', code: 'BH', ddl: 'BH', cid: 216, r: 124},
    {id: 125, name: 'Bolton', code: 'BL', ddl: 'BL', cid: 216, r: 125},
    {id: 126, name: 'Brighton', code: 'BN', ddl: 'BN', cid: 216, r: 126},
    {id: 127, name: 'Bromley', code: 'BR', ddl: 'BR', cid: 216, r: 127},
    {id: 128, name: 'Bristol', code: 'BS', ddl: 'BS', cid: 216, r: 128},
    {id: 129, name: 'Belfast', code: 'BT', ddl: 'BT', cid: 216, r: 129},
    {id: 130, name: 'Carlisle', code: 'CA', ddl: 'CA', cid: 216, r: 130},
    {id: 131, name: 'Cambridge', code: 'CB', ddl: 'CB', cid: 216, r: 131},
    {id: 132, name: 'Cardiff', code: 'CF', ddl: 'CF', cid: 216, r: 132},
    {id: 133, name: 'Chester', code: 'CH', ddl: 'CH', cid: 216, r: 133},
    {id: 134, name: 'Chelmsford', code: 'CM', ddl: 'CM', cid: 216, r: 134},
    {id: 135, name: 'Colchester', code: 'CO', ddl: 'CO', cid: 216, r: 135},
    {id: 136, name: 'Croydon', code: 'CR', ddl: 'CR', cid: 216, r: 136},
    {id: 137, name: 'Canterbury', code: 'CT', ddl: 'CT', cid: 216, r: 137},
    {id: 138, name: 'Coventry', code: 'CV', ddl: 'CV', cid: 216, r: 138},
    {id: 139, name: 'Crewe', code: 'CW', ddl: 'CW', cid: 216, r: 139},
    {id: 140, name: 'Dartford', code: 'DA', ddl: 'DA', cid: 216, r: 140},
    {id: 141, name: 'Dundee', code: 'DD', ddl: 'DD', cid: 216, r: 141},
    {id: 142, name: 'Derby', code: 'DE', ddl: 'DE', cid: 216, r: 142},
    {id: 143, name: 'Dumfries', code: 'DG', ddl: 'DG', cid: 216, r: 143},
    {id: 144, name: 'Durham', code: 'DH', ddl: 'DH', cid: 216, r: 144},
    {id: 145, name: 'Darlington', code: 'DL', ddl: 'DL', cid: 216, r: 145},
    {id: 146, name: 'Doncaster', code: 'DN', ddl: 'DN', cid: 216, r: 146},
    {id: 147, name: 'Dorchester', code: 'DT', ddl: 'DT', cid: 216, r: 147},
    {id: 148, name: 'Dudley', code: 'DY', ddl: 'DY', cid: 216, r: 148},
    {id: 149, name: 'East London', code: 'E ', ddl: 'E', cid: 216, r: 149},
    {id: 150, name: 'East Central London', code: 'EC', ddl: 'EC', cid: 216, r: 150},
    {id: 151, name: 'Edinburgh', code: 'EH', ddl: 'EH', cid: 216, r: 151},
    {id: 152, name: 'Enfield', code: 'EN', ddl: 'EN', cid: 216, r: 152},
    {id: 153, name: 'Exeter', code: 'EX', ddl: 'EX', cid: 216, r: 153},
    {id: 154, name: 'Falkirk', code: 'FK', ddl: 'FK', cid: 216, r: 154},
    {id: 155, name: 'Blackpool', code: 'FY', ddl: 'FY', cid: 216, r: 155},
    {id: 156, name: 'Glasgow', code: 'G ', ddl: 'G', cid: 216, r: 156},
    {id: 157, name: 'Gloucester', code: 'GL', ddl: 'GL', cid: 216, r: 157},
    {id: 158, name: 'Guildford', code: 'GU', ddl: 'GU', cid: 216, r: 158},
    {id: 159, name: 'Harrow', code: 'HA', ddl: 'HA', cid: 216, r: 159},
    {id: 160, name: 'Huddersfield', code: 'HD', ddl: 'HD', cid: 216, r: 160},
    {id: 161, name: 'Harrogate', code: 'HG', ddl: 'HG', cid: 216, r: 161},
    {id: 162, name: 'Hemel Hempstead', code: 'HP', ddl: 'HP', cid: 216, r: 162},
    {id: 163, name: 'Hereford', code: 'HR', ddl: 'HR', cid: 216, r: 163},
    {id: 164, name: 'Hebrides', code: 'HS', ddl: 'HS', cid: 216, r: 164},
    {id: 165, name: 'Hull', code: 'HU', ddl: 'HU', cid: 216, r: 165},
    {id: 166, name: 'Halifax', code: 'HX', ddl: 'HX', cid: 216, r: 166},
    {id: 167, name: 'Ilford', code: 'IG', ddl: 'IG', cid: 216, r: 167},
    {id: 168, name: 'Ipswich', code: 'IP', ddl: 'IP', cid: 216, r: 168},
    {id: 169, name: 'Inverness', code: 'IV', ddl: 'IV', cid: 216, r: 169},
    {id: 170, name: 'Kilmarnock', code: 'KA', ddl: 'KA', cid: 216, r: 170},
    {id: 171, name: 'Kingston upon Thames', code: 'KT', ddl: 'KT', cid: 216, r: 171},
    {id: 172, name: 'Kirkwall', code: 'KW', ddl: 'KW', cid: 216, r: 172},
    {id: 173, name: 'Kirkcaldy', code: 'KY', ddl: 'KY', cid: 216, r: 173},
    {id: 174, name: 'Liverpool', code: 'L ', ddl: 'L', cid: 216, r: 174},
    {id: 175, name: 'Lancaster', code: 'LA', ddl: 'LA', cid: 216, r: 175},
    {id: 176, name: 'Llandrindod Wells', code: 'LD', ddl: 'LD', cid: 216, r: 176},
    {id: 177, name: 'Leicester', code: 'LE', ddl: 'LE', cid: 216, r: 177},
    {id: 178, name: 'Llandudno', code: 'LL', ddl: 'LL', cid: 216, r: 178},
    {id: 179, name: 'Lincoln', code: 'LN', ddl: 'LN', cid: 216, r: 179},
    {id: 180, name: 'Leeds', code: 'LS', ddl: 'LS', cid: 216, r: 180},
    {id: 181, name: 'Luton', code: 'LU', ddl: 'LU', cid: 216, r: 181},
    {id: 182, name: 'Manchester', code: 'M ', ddl: 'M', cid: 216, r: 182},
    {id: 183, name: 'Medway', code: 'ME', ddl: 'ME', cid: 216, r: 183},
    {id: 184, name: 'Milton Keynes', code: 'MK', ddl: 'MK', cid: 216, r: 184},
    {id: 185, name: 'Motherwell', code: 'ML', ddl: 'ML', cid: 216, r: 185},
    {id: 186, name: 'North London', code: 'N ', ddl: 'N', cid: 216, r: 186},
    {id: 187, name: 'Newcastle upon Tyne', code: 'NE', ddl: 'NE', cid: 216, r: 187},
    {id: 188, name: 'Nottingham', code: 'NG', ddl: 'NG', cid: 216, r: 188},
    {id: 189, name: 'Northampton', code: 'NN', ddl: 'NN', cid: 216, r: 189},
    {id: 190, name: 'Newport', code: 'NP', ddl: 'NP', cid: 216, r: 190},
    {id: 191, name: 'Norwich', code: 'NR', ddl: 'NR', cid: 216, r: 191},
    {id: 192, name: 'North West London', code: 'NW', ddl: 'NW', cid: 216, r: 192},
    {id: 193, name: 'Oldham', code: 'OL', ddl: 'OL', cid: 216, r: 193},
    {id: 194, name: 'Oxford', code: 'OX', ddl: 'OX', cid: 216, r: 194},
    {id: 195, name: 'Paisley', code: 'PA', ddl: 'PA', cid: 216, r: 195},
    {id: 196, name: 'Peterborough', code: 'PE', ddl: 'PE', cid: 216, r: 196},
    {id: 197, name: 'Perth', code: 'PH', ddl: 'PH', cid: 216, r: 197},
    {id: 198, name: 'Plymouth', code: 'PL', ddl: 'PL', cid: 216, r: 198},
    {id: 199, name: 'Portsmouth', code: 'PO', ddl: 'PO', cid: 216, r: 199},
    {id: 200, name: 'Preston', code: 'PR', ddl: 'PR', cid: 216, r: 200},
    {id: 201, name: 'Reading', code: 'RG', ddl: 'RG', cid: 216, r: 201},
    {id: 202, name: 'Redhill', code: 'RH', ddl: 'RH', cid: 216, r: 202},
    {id: 203, name: 'Romford', code: 'RM', ddl: 'RM', cid: 216, r: 203},
    {id: 204, name: 'Sheffield', code: 'S ', ddl: 'S', cid: 216, r: 204},
    {id: 205, name: 'Swansea', code: 'SA', ddl: 'SA', cid: 216, r: 205},
    {id: 206, name: 'South East London', code: 'SE', ddl: 'SE', cid: 216, r: 206},
    {id: 207, name: 'Stevenage', code: 'SG', ddl: 'SG', cid: 216, r: 207},
    {id: 208, name: 'Stockport', code: 'SK', ddl: 'SK', cid: 216, r: 208},
    {id: 209, name: 'Slough', code: 'SL', ddl: 'SL', cid: 216, r: 209},
    {id: 210, name: 'Sutton', code: 'SM', ddl: 'SM', cid: 216, r: 210},
    {id: 211, name: 'Swindon', code: 'SN', ddl: 'SN', cid: 216, r: 211},
    {id: 212, name: 'Southampton', code: 'SO', ddl: 'SO', cid: 216, r: 212},
    {id: 213, name: 'Salisbury', code: 'SP', ddl: 'SP', cid: 216, r: 213},
    {id: 214, name: 'Sunderland', code: 'SR', ddl: 'SR', cid: 216, r: 214},
    {id: 215, name: 'Southend-on-Sea', code: 'SS', ddl: 'SS', cid: 216, r: 215},
    {id: 216, name: 'Stoke-on-Trent', code: 'ST', ddl: 'ST', cid: 216, r: 216},
    {id: 217, name: 'South West London', code: 'SW', ddl: 'SW', cid: 216, r: 217},
    {id: 218, name: 'Shrewsbury', code: 'SY', ddl: 'SY', cid: 216, r: 218},
    {id: 219, name: 'Taunton', code: 'TA', ddl: 'TA', cid: 216, r: 219},
    {id: 220, name: 'Galashiels', code: 'TD', ddl: 'TD', cid: 216, r: 220},
    {id: 221, name: 'Telford', code: 'TF', ddl: 'TF', cid: 216, r: 221},
    {id: 222, name: 'Tunbridge Wells', code: 'TN', ddl: 'TN', cid: 216, r: 222},
    {id: 223, name: 'Torquay', code: 'TQ', ddl: 'TQ', cid: 216, r: 223},
    {id: 224, name: 'Truro', code: 'TR', ddl: 'TR', cid: 216, r: 224},
    {id: 225, name: 'Teesside', code: 'TS', ddl: 'TS', cid: 216, r: 225},
    {id: 226, name: 'Twickenham', code: 'TW', ddl: 'TW', cid: 216, r: 226},
    {id: 227, name: 'Southall', code: 'UB', ddl: 'UB', cid: 216, r: 227},
    {id: 228, name: 'West London', code: 'W ', ddl: 'W', cid: 216, r: 228},
    {id: 229, name: 'Warrington', code: 'WA', ddl: 'WA', cid: 216, r: 229},
    {id: 230, name: 'West Central London', code: 'WC', ddl: 'WC', cid: 216, r: 230},
    {id: 231, name: 'Watford', code: 'WD', ddl: 'WD', cid: 216, r: 231},
    {id: 232, name: 'Wakefield', code: 'WF', ddl: 'WF', cid: 216, r: 232},
    {id: 233, name: 'Wigan', code: 'WN', ddl: 'WN', cid: 216, r: 233},
    {id: 234, name: 'Worcester', code: 'WR', ddl: 'WR', cid: 216, r: 234},
    {id: 235, name: 'Walsall', code: 'WS', ddl: 'WS', cid: 216, r: 235},
    {id: 236, name: 'Wolverhampton', code: 'WV', ddl: 'WV', cid: 216, r: 236},
    {id: 237, name: 'York', code: 'YO', ddl: 'YO', cid: 216, r: 237},
    {id: 238, name: 'Lerwick', code: 'ZE', ddl: 'ZE', cid: 216, r: 238},
    {id: 239, name: 'Okayama', code: '36', ddl: '36', cid: 104, r: 30},
    {id: 240, name: 'Aichi', code: '37', ddl: '37', cid: 104, r: 0},
];
